import React from 'react'

import { makeStyles, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => createStyles({
  imageDiv: {
  },
  image: {
    width: '100%',
    objectFit: 'cover',
    overflow: 'hidden'
  },
}));

const Image = ({ image, src, aspectRatio=0}) => {
  const classes = useStyles()  
  
  const imageSrc = src || (image && image.image_url)
  
  if (aspectRatio != 0) {
    return (
      <div style={{
          width: '100%',
          height: 'auto',
          position: 'relative',
          paddingBottom: `${100/aspectRatio}%`
        }}>
        <div style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'hidden',
            // This is most reliable solution to fill image in the box
            background: `url(${imageSrc}) no-repeat center`,
            backgroundSize: 'cover'
          }}>
          { false && imageSrc &&
            <img style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%'
              }} 
              src={ imageSrc }
              />
          }
        </div>
      </div>
    )
  }

  return (
    <div className={classes.imageDiv}>
      { imageSrc &&
        <img src={ imageSrc } style={{
            maxWidth: '100%',
            minWidth: '100%',
          }}
          />
      }
    </div>
  )
}

export default Image